<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid" />Simpangan Baku
        <div class="card-header-actions">
          <CLink href="#" class="card-header-action btn-setting">
            <a @click="addMapping">
              <CIcon name="cil-plus" />
            </a>
          </CLink>
        </div>
      </CCardHeader>
      <CCardBody>
        <div class="form-group">
          <label>Tahun</label>
          <year-selector @input="changeYear" v-model="newData.year"/>
        </div>
        <div style="overflow: inherit">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Jurusan</th>
                <th>Mata Pelajaran</th>
                <th>Rata-Rata</th>
                <th>Simpangan Baku</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, k) in data.data" :key="k">
                <td>{{k + 1}}</td>
                <td>
                  <span v-if="d.entrance_major">
                    {{d.entrance_major.label}}
                  </span>
                </td>
                <td>{{d.subject.name}}</td>
                <td>{{d.average}}</td>
                <td>{{d.value}}</td>
                <td class="action">
                  <btn-edit @click="doEdit(d.id)" />
                  <btn-delete @click="doDelete(d.id)" v-show="!d.deleted_at" />
                </td>
              </tr>
              <tr class="row-input">
                <td colspan="2">
                  <entrance-major v-model="newData.entrance_major" />
                </td>
                <td>
                  <subject-selector v-model="newData.subject" />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="newData.average"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="newData.value"
                  />
                </td>
                <td class="row-input-button" align="center">
                  <button class="btn btn-success" @click="save">Save</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
      <CCardFooter>
        <content-pagination
          :page="paginate.page"
          :size="paginate.size"
          :total="paginate.total"
          @input="loadPage"
        />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import EntranceMajor from "../../components/EntranceMajor"
import YearSelector from "../../components/YearSelector"
import SubjectSelector from "../../components/SubjectSelector"
import ContentPagination from "../../components/ContentPagination";
import BtnEdit from "../../components/BtnEdit";
import BtnDelete from "../../components/BtnDelete";
import { showErrorMessage } from '../../lib/helpers';
import {format} from 'date-fns';

export default {
  components: {
    YearSelector,
    ContentPagination,
    BtnEdit,
    BtnDelete,
    EntranceMajor,
    SubjectSelector,
  },
  data() {
    return {
      data: {},
      paginate: {},
      newData: {},
    };
  },
  created() {
    const query = this.$route.query;
    if (query && query.year) {
      this.load(query.year, 1);
    } else {
      const year = format(new Date(), 'Y');
      this.load(year, 1);
    }
  },
  methods: {
    load(year, page) {
      var qYear = "";
      if (year && year != "") {
        qYear = `year=${year}`;
        this.newData.year = {
          label: year
        };
        this.$router.push({query: {year: year}}).catch(() => {});
      }
      console.log(year, page)
      HTTPAUTH.get(
        `/api/v1/admin/mapping/standard-deviation?page=${page}&size=10&${qYear}`
      ).then((res) => {
        this.data = res.data;
        this.paginate = this.data.paginate;
      });
    },
    loadPage(page) {
      let year = ""
      const query = this.$route.query;
      if (query && query.year) {
        year = query.year
      } else {
        year = format(new Date(), 'Y');
      }
      this.load(year, page);
    },
    addMapping() {
      this.$router.push({ path: "/mapping/standard-deviation/new" });
    },
    changeYear(y) {
      const query = this.$route.query;
      if (query && query.page) {
        this.load(y.label, query.page);
        return;
      }
      this.load(y.label, 1);
    },
    doDelete(id) {
      HTTPAUTH.delete(`/api/v1/admin/mapping/standard-deviation/${id}`).then(() => {
        this.load(this.newData.year, "");
      }).catch(eres => {
        showErrorMessage(eres)
      })
    },
    doEdit(id) {
      this.$router.push({ path: "/mapping/standard-deviation/" + id });
    },
    save() {
      const data = this.newData;
      if (data.subject) {
        data.subject_id = data.subject.id;
      }
      if (data.entrance_major) {
        data.entrance_major_id = data.entrance_major.id;
      }
      if (data.year) {
        data.year = data.year.label;
      }
      HTTPAUTH.post(`/api/v1/admin/mapping/standard-deviation`, data)
        .then(() => {
          this.$toasted.success("Data berhasil disimpan").goAway();
          this.load(data.year, 1);
          this.newData = {};
        })
        .catch((eres) => {
          data.year = {
            label: data.year,
          };
          this.errors = showErrorMessage(eres)
        });
    },
  },
};
</script>